import { render, staticRenderFns } from "./DropdownInput.vue?vue&type=template&id=64bb0524&scoped=true"
import script from "./DropdownInput.vue?vue&type=script&lang=js"
export * from "./DropdownInput.vue?vue&type=script&lang=js"
import style0 from "./DropdownInput.vue?vue&type=style&index=0&id=64bb0524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb0524",
  null
  
)

export default component.exports